import React from 'react'
import SubHeader from '../general/SubHeader'

const PrivacyPolicy = () => {
  return (
    <>
      <SubHeader message="Privacy Policy" />

      <section className='my-5'>
        <div className='container'>

<p className='fs-5 fw-semibold'>Privacy Policy for HarGharMart </p>

<p>Effective Date: 11 August 2026<br /><br />

Welcome to HarGharMart (“we”, “our”, or “us”). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit or make a purchase from our website.</p>

<p className='fw-bold'>Information We Collect</p>
<p>When you visit our website or purchase products, we may collect the following information: -<br />
● Personal Information: Name, email address, phone number, shipping address, billing address, and payment details.<br />
● Order Information: Items ordered, transaction history, and communication related to your purchase.
</p>

<p className='fw-bold'>How We Use Your Information?</p>
<p>We use your information to: -<br />
● Process and fulfill orders.<br />
● Communicate order updates and respond to inquiries.<br />
● Improve our products, services, and user experience.<br />
● Prevent fraud and ensure site security.</p>

<p className='fw-bold'>Sharing Your Information</p>
<p>We do not sell or rent your personal information. However, we may share it with: -<br />
● Trusted third-party services: Such as payment processors, shipping providers, and marketing tools—strictly for business operations.<br />
● Legal Authorities: When required by law or to protect our rights and safety.</p>

<p className='fw-bold'>Data Security</p>
<p>We take appropriate security measures to protect your personal information. While no method is 100% secure, we use encrypted channels and secure payment gateways.</p>

<p className='fw-bold'>Your Rights</p>
<p>You have the right to: -<br />
Access, update, or delete your personal data.<br />
Opt out of promotional communications at any time.<br />
Request details on the data we hold about you.</p>

<p className='fw-bold'>Changes to this Policy</p>
<p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated date.</p>

<p className='fw-bold'>Contact Us</p>
<p>If you have any questions about this Privacy Policy, please contact us at: -<br />
📧 Email:support@hargharmart.com<br />
📞 Phone: +91 7398573394 <br />
🌐 Website: hargharmart.com</p>

        </div>
      </section>
    </>
  )
}

export default PrivacyPolicy
